export default {
  // Customers
  customers: {
    createNew: 'ဖောက်သည်အသစ် ဖန်တီးရန်',
    phoneNumber: 'ဖုန်းနံပါတ်',
    name: 'ဖောက်သည်အမည်',
    enterName: 'ဖောက်သည်အမည် ရိုက်ထည့်ပါ',
    externalReference: 'ပြင်ပ ရည်ညွှန်းချက်',
    enterExternalReference: 'ပြင်ပ ရည်ညွှန်းချက် ရိုက်ထည့်ပါ (ထည့်လိုလျှင်)',
    search: 'ဖောက်သည်များ ရှာဖွေရန်',
    noResults: 'ဖောက်သည်များ မတွေ့ရှိပါ',
    create: 'ဖောက်သည် ဖန်တီးရန်',
    edit: 'ဖောက်သည် ပြင်ဆင်ရန်',
    details: 'ဖောက်သည် အချက်အလက်များ',
    contactInfo: 'ဆက်သွယ်ရန် အချက်အလက်'
  },

  // Languages
  languages: {
    en: 'English',
    my: 'မြန်မာ'
  },

  // Notifications
  notifications: {
    disableSound: 'အသံကို ပိတ်ရန်',
    enableSound: 'အသံကို ဖွင့်ရန်',
    newTicket: 'တစ်ကတ်အသစ် ဖန်တီးပြီးပါပြီ',
    ticketUpdated: 'တစ်ကတ် #{{id}} အပ်ဒိတ်လုပ်ပြီးပါပြီ',
    ticketAssigned: 'တစ်ကတ်ကို သင့်ထံ တာဝန်ပေးအပ်ထားပါသည်',
    ticketResolved: 'တစ်ကတ် ဖြေရှင်းပြီးပါပြီ',
    ticketClosed: 'တစ်ကတ် ပိတ်သိမ်းပြီးပါပြီ',
    received: 'အကြောင်းကြားချက် ရရှိပါပြီ',
    markAllReadError:
      'အကြောင်းကြားချက်အားလုံးကို ဖတ်ပြီးအဖြစ် မှတ်သားရန် မအောင်မြင်ပါ။ ထပ်မံကြိုးစားပါ။',
    noAssociatedTicket: 'ဤအကြောင်းကြားချက်တွင် သက်ဆိုင်သည့် တစ်ကတ် မရှိပါ။',
    navigationError: 'တစ်ကတ်သို့ သွားရန် မရပါ။ ထပ်မံကြိုးစားပါ။'
  },

  // Authentication
  auth: {
    loginFailed: 'အကောင့်ဝင်ရန် မအောင်မြင်ပါ',
    organizationSubdomain: 'အဖွဲ့အစည်း ဆပ်ဒိုမိန်း',
    subdomainRequired: 'အဖွဲ့အစည်း ဆပ်ဒိုမိန်း လိုအပ်ပါသည်',
    invalidSubdomain: 'ဆပ်ဒိုမိန်း ပုံစံ မမှန်ကန်ပါ',
    subdomainPlaceholder: 'သင့်အဖွဲ့အစည်း',
    subdomainHelpText:
      'မှန်ကန်သော အဖွဲ့အစည်းသို့ ချိတ်ဆက်ရန် သင့်အဖွဲ့အစည်း၏ ဆပ်ဒိုမိန်းကို ရိုက်ထည့်ပါ။ သင့်အဖွဲ့အစည်း၏ ဆပ်ဒိုမိန်းကို မသိလျှင် သင့်စီမံခန့်ခွဲသူကို ဆက်သွယ်ပါ။',
    domain: '.flowcxp.com',
    loggingIntoOrg: 'သင်သည် ဝင်ရောက်နေသည့် အဖွဲ့အစည်း',
    devMode: '(ဒေါင်းလုပ်မင့်ပုံစံ)',
    emailAddress: 'အီးမေးလ် လိပ်စာ',
    emailRequired: 'အီးမေးလ် လိုအပ်ပါသည်',
    invalidEmail: 'အီးမေးလ် လိပ်စာ မမှန်ကန်ပါ',
    emailPlaceholder: 'you@example.com',
    password: 'စကားဝှက်',
    passwordRequired: 'စကားဝှက် လိုအပ်ပါသည်',
    passwordMinLength: 'စကားဝှက်သည် အနည်းဆုံး ၆ လုံး ရှိရပါမည်',
    passwordPlaceholder: 'စကားဝှက်ရိုက်ထည့်ပါ',
    forgotPassword: 'စကားဝှက်မေ့သွားပါသလား?',
    signingIn: 'ဝင်ရောက်နေသည်...',
    signIn: 'ဝင်ရောက်ရန်',
    forgotPasswordTitle: 'စကားဝှက်မေ့သွားပါသလား?',
    contactAdmin: 'စကားဝှက်ပြန်လည်သတ်မှတ်ရန် သင့်စနစ်စီမံခန့်ခွဲသူကို ဆက်သွယ်ပါ။',
    email: 'အီးမေးလ်: ',
    phone: 'ဖုန်း: '
  },

  // Forms
  forms: {
    fieldRequired: '{{field}} လိုအပ်ပါသည်',
    selectField: '{{field}} ရွေးချယ်ပါ',
    enterToSearch: 'ရှာဖွေရန် ရိုက်ထည့်ပါ',
    priorityLevel: 'ဦးစားပေးအဆင့်',
    priorityLevelDescription: 'Ticket ၏ ဦးစားပေးအဆင့်ကို သတ်မှတ်ပေးပါ',
    ticketMainInfo: 'အမျိုးအစားခွဲခြားခြင်း',
    ticketMainInfoDescription: 'ဤ Ticketကို Tag နှင့် အမျိုးအစား သတ်မှတ်ပါ',
    assignmentTitle: 'တာဝန်ပေးအပ်ခြင်း',
    assignmentDescription: 'ဤ Ticketကို သက်ဆိုင်ရာ အေးဂျင့်ထံသို့ တာဝန်ပေးအပ်ရန်',
    ticketDetailTitle: 'Ticket အသေးစိတ်',
    ticketDetailDescription: 'ဖော်ပြချက်၊ တမ်းပလိတ်များနှင့် ပူးတွဲဖိုင်များ ထည့်သွင်းပါ',
    description: 'Ticket အသေးစိတ်ဖော်ပြချက်',
    attachments: 'ပူးတွဲဖိုင်များ',
    validation: {
      required: 'ဤနေရာကို ဖြည့်ရန်လိုအပ်ပါသည်',
      minLength: 'အနည်းဆုံး {{min}} လုံး ရှိရပါမည်',
      maxLength: '{{max}} လုံးထက် မပိုရပါ',
      invalidFormat: 'ပုံစံ မမှန်ကန်ပါ'
    }
  },

  // Common UI elements
  common: {
    loading: 'စောင့်ဆိုင်းနေသည်...',
    error: 'အမှားအယွင်းတစ်ခု ဖြစ်ပွားခဲ့သည်',
    success: 'အောင်မြင်သည်',
    noData: 'အချက်အလက် မရှိပါ',
    none: 'မရှိပါ',
    email: 'အီးမေးလ်',
    phone: 'ဖုန်း',
    createTicket: 'တောင်းဆိုချက် အသစ်ဖန်တီးရန်',
    submit: 'တင်သွင်းရန်',
    save: 'သိမ်းဆည်းရန်',
    cancel: 'ပယ်ဖျက်ရန်',
    close: 'ပိတ်ရန်',
    confirm: 'အတည်ပြုရန်',
    search: 'ရှာဖွေရန်',
    filter: 'စီစစ်ရန်',
    reset: 'ပြန်လည်သတ်မှတ်ရန်',
    apply: 'အသုံးပြုရန်',
    to: 'မှ',
    create: 'ဖန်တီးရန်',
    creating: 'ဖန်တီးနေသည်...',
    settings: 'ဆက်တင်များ',
    appLogo: 'FlowCXP လိုဂို',
    appName: 'FlowCXP',
    profile: 'ပရိုဖိုင်',
    logout: 'ထွက်ရန်',
    notifications: 'အသိပေးချက်များ',
    markAllAsRead: 'အားလုံးကို ဖတ်ပြီးအဖြစ် မှတ်သားရန်',
    noNotifications: 'ဖတ်ရန်ကျန်သော အသိပေးချက်များ မရှိပါ',
    connected: 'ချိတ်ဆက်ထားသည်',
    disconnected: 'ချိတ်ဆက်မှု ပြတ်တောက်သွားသည်',
    connectionError: 'ချိတ်ဆက်မှု အမှား',
    language: 'ဘာသာစကား',
    lightMode: 'အလင်းရောင်မုဒ်',
    darkMode: 'အမှောင်ရောင်မုဒ်',
    fullScreen: 'မျက်နှာပြင်အပြည့်',
    exitFullScreen: 'မျက်နှာပြင်အပြည့်မှ ထွက်ရန်',
    changeLanguage: 'ဘာသာစကား ပြောင်းရန်',
    localizationTest: 'ဘာသာပြန်ဆိုချက် စမ်းသပ်စာမျက်နှာ',
    currentSettings: 'လက်ရှိ ဆက်တင်များ',
    currentLanguage: 'လက်ရှိ ဘာသာစကား',
    currentTheme: 'လက်ရှိ အသွင်အပြင်',
    dark: 'အမှောင်',
    light: 'အလင်း',
    translationSamples: 'ဘာသာပြန်ဆိုချက် နမူနာများ',
    commonElements: 'အသုံးများသော UI အစိတ်အပိုင်းများ',
    apiExamples: 'API ရက်စွဲ ဖော်မက်ချက် နမူနာများ',
    accessDenied: 'ဝင်ရောက်ခွင့် ပိတ်ပင်ထားသည်',
    accessDeniedMessage:
      'သင့်တွင် ဤအရင်းအမြစ်ကို ဝင်ရောက်ခွင့် မရှိပါ။ သင့်စီမံခန့်ခွဲသူကို ဆက်သွယ်ပါ။',
    returnToDashboard: 'ဒက်ရှ်ဘုတ်သို့ ပြန်သွားရန်',
    previous: 'နောက်သို့',
    next: 'ရှေ့သို့',
    showing: 'ပြသနေသည်',
    of: 'မှ',
    error404: 'သင်ရှာနေသော စာမျက်နှာမရှိပါ။',
    error401: 'ဤစာမျက်နှာကို ဝင်ရောက်ခွင့်မရှိပါ။',
    error403: 'ဤစာမျက်နှာကို ဝင်ရောက်ခွင့်မရှိပါ။',
    error503: 'ဤဝန်ဆောင်မှုသည် ယခုအသုံးမပြုနိုင်သေးပါ။',
    errorGeneric: 'တစ်ခုခုမှားယွင်းသွားပါပြီ။',
    errorUnexpected: 'မမျှော်လင့်ထားသည့် အခက်အခဲတစ်ခု ဖြစ်သွားပါသည်။',
    applicationError: 'အက်ပ်ပလီကေးရှင်း အမှား',
    goBack: 'နောက်သို့ပြန်သွားပါ',
    goHome: 'ပင်မစာမျက်နှာသို့သွားပါ',
    unknown: 'အမည်မသိ',
    test: 'စမ်းသပ်ရန်',
    testing: 'စမ်းသပ်နေသည်...'
  },

  // Tenant Information
  tenantInfo: {
    organizationInformation: 'အဖွဲ့အစည်း အချက်အလက်များ',
    active: 'အဆင်သင့်',
    organizationName: 'အဖွဲ့အစည်းမျိုး',
    subdomain: 'ဆဘ်ဒိုမိန်း',
    tenantId: 'အဖွဲ့အစည်း ID',
    totalAgents: 'အေးဂျင့်စုစုပေါင်း'
  },

  // Navigation
  navigation: {
    backTo: 'ပြန်သွားရန်',
    dashboard: 'ဒက်ရှ်ဘုတ်',
    tickets: 'လုပ်ဆောင်ရန် ရှိသည်များ',
    ticketWall: 'အလုပ် စားပွဲ',
    myWorkspace: 'ကျွန်ုပ်၏ အလုပ်ခန်း',
    reports: 'အစီရင်ခံစာများ',
    settings: 'ဆက်တင်များ',
    myMemo: 'ကျွန်ုပ်၏ မှတ်စုများ',
    myMemos: 'ကျွန်ုပ်၏ မှတ်စုများ',
    changePassword: 'စကားဝှက် ပြောင်းလဲရန်',
    contact: 'ဆက်သွယ်ရန်',
    backToHome: 'ပင်မစာမျက်နှာသို့ ပြန်သွားရန်',
    privacyPolicy: 'ကိုယ်ရေးကိုယ်တာ မူဝါဒ',
    termsOfService: 'ဝန်ဆောင်မှု စည်းကမ်းချက်များ',
    localizationTest: 'ဘာသာပြန်ဆိုချက် စမ်းသပ်ရန်',
    features: 'လုပ်ဆောင်ချက်များ',
    pricing: 'စျေးနှုန်းများ',
    atrium: 'The Atrium'
  },
  // Pages
  pages: {
    contact: {
      title: 'ဆက်သွယ်ရန်',
      subtitle: 'ကျွန်ုပ်၏ အဖွဲ့အစည်းသို့ ဆက်သွယ်ရန်',
      officeHours: 'အိုးရာ အချိန်',
      headquarters: 'အဖွဲ့အစည်း အိုးရာ'
    },
    tickets: {
      title: 'လုပ်ဆောင်ရန် ရှိသည်များ',
      tags: 'တဂ်များ',
      groups: 'အုပ်စုအဖွဲ့များ',
      categories: 'အမျိုးအစားများ',
      sources: 'ရင်းမြစ်များ',
      totalTickets: 'စုစုပေါင်း',
      allStatuses: 'အခြေအနေအားလုံး',
      requestedBy: 'တောင်းဆိုသူ',
      assignedTo: 'တာဝန်ပေးထားသူ',
      filterByGroups: 'အုပ်စုအဖွဲ့များဖြင့် စစ်ထုတ်ရန်...',
      filterByRequesters: 'တောင်းဆိုသူများဖြင့် စစ်ထုတ်ရန်...',
      filterByAssignees: 'တာဝန်ပေးထားသူများဖြင့် စစ်ထုတ်ရန်...',
      filterByTags: 'တဂ်များဖြင့် စစ်ထုတ်ရန်...',
      filterByCategories: 'အမျိုးအစားများဖြင့် စစ်ထုတ်ရန်...',
      filterBySources: 'ရင်းမြစ်များဖြင့် စစ်ထုတ်ရန်...',
      hideFilters: 'စစ်ထုတ်မှုများကို ဖျောက်ရန်',
      showFilters: 'စစ်ထုတ်မှုများကို ပြရန်',
      noTicketsFound: 'တောင်းဆိုချက်များ မတွေ့ရှိပါ',
      view: 'ကြည့်ရှုပုံစံ',
      tableView: 'ဇယား',
      listView: 'စာရင်း',
      kanbanView: 'ကန်ဘန်'
    },
    // Create Ticket
    createTicket: {
      title: 'တောင်းဆိုချက် ဖန်တီးရန်',
      description: 'Support Ticket အသစ်ဖွင့်ရန် အချက်အလက်များဖြည့်ပါ',
      error: 'တောင်းဆိုချက် ဖန်တီးရန် မအောင်မြင်ပါ။ ထပ်မံကြိုးစားပါ။',
      fields: {
        title: 'ခေါင်းစဉ်',
        titlePlaceholder: 'တောင်းဆိုချက်ခေါင်းစဉ် ရိုက်ထည့်ပါ',
        titleToggle: {
          auto: 'အလိုအလျောက်ထည့်သွင်း',
          manual: 'ကိုယ်တိုင်ထည့်သွင်း'
        },
        description: 'ဖော်ပြချက်',
        descriptionPlaceholder: 'တောင်းဆိုချက်ဖော်ပြချက် ရိုက်ထည့်ပါ',
        searchCustomer: 'ဝယ်ယူသူ ရှာရန်',
        searchCustomerByPhone: 'ဖုန်းနံပါတ်ဖြင့် ဝယ်ယူသူ ရှာရန်',
        searching: 'ရှာနေသည်...',
        search: 'ရှာရန်',
        select: 'ရွေးချယ်ပါ',
        edit: 'ပြုပြီးပြုပါ',
        foundCustomers: 'ဝယ်ယူသူ {{count}} ယောက်တွေ့ရှိသည်',
        foundCustomersPlural: 'ဝယ်ယူသူ {{count}} ယောက်တွေ့ရှိသည်',
        loadingTags: 'တဂ်များ ဖတ်ယူနေသည်...',
        noTagsAvailable: 'တဂ်များ မရှိပါ',
        typeAtLeastOneChar: 'အနည်းဆုံး စာလုံး ၁ လုံး ရိုက်ထည့်ပါ',
        noMatchingTags: 'ကိုက်ညီသော တဂ်များ မရှိပါ',
        priority: 'ဦးစားပေးအဆင့်',
        status: 'အခြေအနေ',
        assignee: 'တာဝန်ပေးထားသူ',
        category: 'အမျိုးအစား',
        type: 'အမျိုးအစား',
        source: 'ရင်းမြစ်',
        tags: 'တဂ်များ',
        attachments: 'ပူးတွဲဖိုင်များ',
        comments: 'မှတ်ချက်များ',
        assignToAgent: 'အေးဂျင့်သို့ တာဝန်ပေးရန်',
        assignToGroup: 'အဖွဲ့သို့ တာဝန်ပေးရန်',
        tagsPlaceholder: 'တဂ်များ ရွေးချယ် သို့မဟုတ် ရှာဖွေရန်...',
        ticketDetails: 'တောင်းဆိုချက် အသေးစိတ်',
        templates: 'ပုံစံများ',
        selectTemplate: 'ပုံစံတစ်ခု ရွေးချယ်ပါ',
        loadingTemplates: 'ပုံစံများ ဖတ်ယူနေသည်...',
        notifyCustomer: 'ဖောက်သည်ကို အကြောင်းကြားရန်',
        notifyCustomerDescription:
          'တောင်းဆိုချက်အကြောင်း ဖောက်သည်ကို Push Notification မှတဆင့် အသိပေးရန်'
      }
    },
    myMemo: {
      title: 'ကျွန်ုပ်၏ မှတ်စုများ',
      newMemo: 'မှတ်စုအသစ်',
      arrangeInGrid: 'ဇယားကွက်ပုံစံ စီစဉ်ရန်',
      loadError: 'မှတ်စုများကို ဖွင့်၍မရပါ',
      createError: 'မှတ်စုအသစ် ဖန်တီးရန် မအောင်မြင်ပါ',
      updateError: 'မှတ်စု ပြင်ဆင်ရန် မအောင်မြင်ပါ',
      deleteError: 'မှတ်စု ဖျက်ရန် မအောင်မြင်ပါ',
      loginRequired: 'သင့်မှတ်စုများကို ကြည့်ရှုရန် အကောင့်ဝင်ပါ',
      searchPlaceholder: 'မှတ်စုများကို ရှာဖွေရန်...',
      memoCount: 'မှတ်စု {{count}} ခု',
      noMemos: 'မှတ်စုများ မရှိသေးပါ',
      noMatchingMemos: 'ကိုက်ညီသော မှတ်စုများ မရှိပါ',
      tryDifferentSearch: 'အခြား ရှာဖွေမှုစကားလုံး ကြိုးစားကြည့်ပါ',
      createFirstMemo: 'စတင်ရန် သင့်ပထမဆုံး မှတ်စုကို ဖန်တီးပါ',
      createNewMemo: 'မှတ်စုအသစ် ဖန်တီးရန်'
    },
    ticketWall: {
      title: 'အလုပ် စားပွဲပွဲ'
    },
    dashboard: {
      title: 'ဒက်ရှ်ဘုတ်',
      overview: 'အကျဉ်းချုပ်',
      topContributors: 'ထိပ်တန်း ပံ့ပိုးသူများ',
      recentActivity: 'လတ်တလော လုပ်ဆောင်ချက်များ',
      ticketBreakdown: 'တောင်းဆိုချက် အမျိုးအစားခွဲခြမ်းမှု',
      quickStats: 'အမြန် စာရင်းအင်းများ',
      ticketStats: 'တောင်းဆိုချက် စာရင်းအင်းများ',
      exportData: 'အချက်အလက်များ ထုတ်ယူရန်',
      dateRangeReport: 'ရက်စွဲအပိုင်းအခြား အစီရင်ခံစာ',
      ticketsExport: 'တောင်းဆိုချက်များ',
      exporting: 'ထုတ်ယူနေသည်...',
      export: 'ထုတ်ယူရန်',
      preparingExport: 'ထုတ်ယူရန် ပြင်ဆင်နေသည်...',
      failedToLoadStats: 'ဒက်ရှ်ဘုတ် အချက်အလက်များ မတ်တမ်းများကို အမှားအယွင်း မလိုက်နိုင်ပါ'
    },
    reports: {
      title: 'အစီရင်ခံစာများ',
      export: 'ထုတ်ယူရန်',
      exporting: 'ထုတ်ယူနေသည်...',
      preparingExport: 'ထုတ်ယူရန် ပြင်ဆင်နေသည်...',
      ticketsExport: 'တောင်းဆိုချက်များ-ထုတ်ယူမှု',
      accessDenied: 'အစီရင်ခံစာများကို ကြည့်ရှုခွင့် မရှိပါ'
    },
    settings: {
      title: 'ဆက်တင်များ'
    },
    ticketDetail: {
      type: 'အမျိုးအစား',
      category: 'အမျိုးအစား',
      saveChanges: 'ပြောင်းလဲမှုများသိမ်းရန်',
      cancel: 'ပယ်ဖျက်မည်',
      ticketDetail: 'တောင်းဆိုချက် အသေးစိတ်',
      unassigned: 'တာဝန်မပေးထားသေး',
      assignToMe: 'မိမိတာဝန်ယူမည်',
      deleteTicket: 'တောင်းဆိုချက်ကို ဖျက်ရန်',
      noAttachments: 'ပူးတွဲဖိုင်များမရှိပါ',
      newAttachmentsPreview: 'ပူးတွဲဖိုင်အသစ်များကြိုကြည့်ရှုခြင်း',
      currentAttachments: 'လက်ရှိပူးတွဲဖိုင်များ',
      addNewAttachments: 'ပူးတွဲဖိုင်အသစ်ထည့်ရန်',
      discussion: 'ဆွေးနွေးမှု',
      source: 'ရင်းမြစ်',
      requester: 'တောင်းဆိုသူ',
      customer: 'ဝယ်ယူသူ',
      group: 'အဖွဲ့',
      assignee: 'တာဝန်ပေးထားသူ',
      tags: 'တဂ်များ',
      attachments: 'ပူးတွဲဖိုင်များ',
      ticketHistory: 'တောင်းဆိုချက် မှတ်တမ်း',
      editTicket: 'တောင်းဆိုချက်ကို ပြင်ဆင်ရန်',
      ticketUpdatedByAnotherUser:
        'တစ်ခြားအသုံးပြုသူတစ်ဦးမှ တောင်းဆိုချက်ကို ပြင်ဆင်ထားပါသည်။ လက်ရှိတည်းဖြတ်မှုကို ပယ်ဖျက်ပြီး ပြန်လည်ကြိုးစားပါ။'
    },
    myWorkspace: {
      title: 'ကျွန်ုပ်၏ အလုပ်ခန်း',
      myOpenTickets: 'ကျွန်ုပ်ဖွင့်ထားသော တောင်းဆိုချက်များ',
      myAssignedTickets: 'ကျွန်ုပ်ကို တာဝန်ပေးထားသော တောင်းဆိုချက်များ',
      openTicketsDescription: 'သင်ဖန်တီးထားသော တောင်းဆိုချက်များ',
      assignedTicketsDescription: 'သင့်ကို တာဝန်ပေးထားသော တောင်းဆိုချက်များ',
      noOpenTickets: 'သင်တောင်းဆိုချက်များ မဖန်တီးရသေးပါ',
      noAssignedTickets: 'လက်ရှိတွင် သင့်ကို တာဝန်ပေးထားသော တောင်းဆိုချက်များ မရှိပါ',
      createFirstTicket: 'သင့်ပထမဆုံး တောင်းဆိုချက်ကို ဖန်တီးပါ',
      ticketsAsRequester: 'တောင်းဆိုသူအဖြစ်',
      ticketsAsAgent: 'အေးဂျင့်အဖြစ်',
      totalOpen: 'စုစုပေါင်း ဖွင့်ထားသော',
      totalAssigned: 'စုစုပေါင်း တာဝန်ပေးထားသော'
    },
    changePassword: {
      title: 'စကားဝှက်ပြောင်းရန်',
      currentPassword: 'လက်ရှိစကားဝှက်',
      newPassword: 'စကားဝှက်အသစ်',
      confirmPassword: 'စကားဝှက်အသစ်ကိုအတည်ပြုပါ',
      success: 'စကားဝှက်အောင်မြင်စွာပြောင်းလဲပြီးပါပြီ',
      failedToChange: 'စကားဝှက်ပြောင်းလဲရန်မအောင်မြင်ပါ',
      validation: {
        currentRequired: 'လက်ရှိစကားဝှက်လိုအပ်ပါသည်',
        minLength: 'စကားဝှက်အသစ်သည် အနည်းဆုံး ၆ လုံးရှိရပါမည်',
        maxLength: 'စကားဝှက်အသစ်သည် ၅၀ လုံးထက်မပိုရပါ',
        confirmRequired: 'စကားဝှက်အသစ်ကိုအတည်ပြုပေးပါ',
        passwordsDontMatch: 'စကားဝှက်များမကိုက်ညီပါ'
      },
      submit: 'သိမ်းဆည်းရန်'
    }
  },

  // Tickets
  tickets: {
    title: 'ခေါင်းစဉ်',
    kanban: {
      dragToReorder: ' အစီအစဉ် ပြန်လုပ်ရန် ဆွဲရန်'
    },
    status: {
      filterTitle: 'အခြေအနေ',
      all: 'အားလုံး',
      new: 'အသစ်',
      unassigned: 'တာဝန်မပေးထားသော',
      processing: 'ဆောင်ရွက်ဆဲ',
      resolved: 'ဖြေရှင်းပြီး',
      closed: 'ပိတ်သိမ်းပြီး'
    },
    priority: 'ဦးစားပေးအဆင့်',
    assignedTo: 'တာဝန်ပေးထားသူ',
    requestedBy: 'တောင်းဆိုသူ',
    filterByGroups: 'အုပ်စုအဖွဲ့များဖြင့် စစ်ထုတ်ရန်...',
    filterByRequesters: 'တောင်းဆိုသူများဖြင့် စစ်ထုတ်ရန်...',
    filterByAssignees: 'တာဝန်ပေးထားသူများဖြင့် စစ်ထုတ်ရန်...',
    noUsersAvailable: 'အသုံးပြုသူ မရှိပါ',
    typeAtLeastOneChar: 'အနည်းဆုံး စာလုံး ၁ လုံး ရိုက်ထည့်ပါ',
    noMatchingUsers: 'ကိုက်ညီသော အသုံးပြုသူ မရှိပါ',
    loadingUsers: 'အသုံးပြုသူများ ဖွင့်နေသည်...',
    allStatuses: 'အခြေအနေအားလုံး',
    createdAt: 'ဖန်တီးသည့်အချိန်',
    updatedAt: 'ပြင်ဆင်သည့်အချိန်',
    createdBy: 'ဖန်တီးသူ',
    dueDate: 'သတ်မှတ်ရက်',
    category: 'အမျိုးအစား',
    type: 'အမျိုးအစား',
    source: 'ရင်းမြစ်',
    group: 'အုပ်စုအဖွဲ့',
    tags: 'တဂ်များ',
    description: 'ဖော်ပြချက်',
    comments: 'မှတ်ချက်များ',
    attachments: 'ပူးတွဲဖိုင်များ',
    addComment: 'မှတ်ချက် ထည့်သွင်းရန်',
    adding: 'ထည့်သွင်းနေသည်...',
    commentRequired: 'မှတ်ချက်တစ်ခု ထည့်သွင်းပေးပါ',
    commentMinLength: 'မှတ်ချက်သည် အနည်းဆုံး စာလုံး ၃ လုံး ရှိရပါမည်',
    commentPlaceholder: 'သင့်မှတ်ချက်ကို ဤနေရာတွင် ရိုက်ထည့်ပါ...',
    addAttachment: 'ဖိုင် ပူးတွဲရန်',
    updateStatus: 'အခြေအနေ ပြောင်းလဲရန်',
    updatePriority: 'ဦးစားပေးအဆင့် ပြောင်းလဲရန်',
    assign: 'တာဝန်ပေးရန်',
    unassign: 'တာဝန်ပြန်ရုပ်သိမ်းရန်',
    open: 'ဖွင့်ထားသည်',
    inProgress: 'ဆောင်ရွက်နေဆဲ',
    resolved: 'ဖြေရှင်းပြီး',
    closed: 'ပိတ်သိမ်းပြီး',
    reopened: 'ပြန်လည်ဖွင့်ထားသည်',
    noTicketsFound: 'တောင်းဆိုချက်များ မတွေ့ရှိပါ',
    createNewTicket: 'တောင်းဆိုချက်အသစ် ဖန်တီးရန်',
    filterByStatus: 'အခြေအနေ စစ်ထုတ်ရန်',

    commentDeletedSuccess: 'မှတ်ချက်ကို အောင်မြင်စွာ ဖျက်ပြီးပါပြီ',
    commentDeleteFailed: 'မှတ်ချက်ကို ဖျက်ရန် မအောင်မြင်ပါ',
    commentCannotBeEmpty: 'မှတ်ချက်သည် ဗလာမဖြစ်ရပါ',
    commentUpdateFailed: 'မှတ်ချက်ကို အပ်ဒိတ်လုပ်ရန် မအောင်မြင်ပါ',
    editComment: 'မှတ်ချက်ကို ပြင်ဆင်ရန်',
    deleteComment: 'မှတ်ချက်ကို ဖျက်ရန်',
    uploadFiles: 'ဖိုင်များ တင်ရန်',
    orDragAndDrop: 'သို့မဟုတ် ဆွဲချ၍ ချပါ',
    fileSizeLimit: '10MB အထိ ဖိုင်များ',
    deleteAttachment: 'ဖိုင်ပူးတွဲကို ဖျက်ရန်',
    download: 'ဒေါင်းလုတ်ရန်',
    created: 'ဖန်တီးချိန်',
    updated: 'ပြင်ဆင်ချိန်',
    ticketNumber: 'တစ်ခက်အမှတ် #',
    lastUpdated: 'နောက်ဆုံးပြင်ဆင်ချိန်',
    imagePasted: 'ပုံကို ပူးတွဲဖိုင်အဖြစ် ကူးထည့်ပြီး',
    maxAttachmentReached: 'ပူးတွဲဖိုင်အများဆုံး {{max}} ဖိုင်ထည့်သွင်းနိုင်ပါသည်',
    statusCounts: {
      total: 'စုစုပေါင်း',
      new: 'အသစ်',
      processing: 'ဆောင်ရွက်ဆဲ',
      resolved: 'ဖြေရှင်းပြီး',
      closed: 'ပိတ်သိမ်းပြီး',
      assigned: 'တာဝန်ပေးထားသော',
      unassigned: 'တာဝန်မပေးရသေးသော'
    },
    sources: {
      email: 'အီးမေးလ်',
      phone: 'ဖုန်း',
      chat: 'ချက်',
      web: 'ဝဘ်ဆိုဒ်'
    },
    groups: {
      techops: 'နည်းပညာအဖွဲ့',
      backops: 'နောက်ခံအဖွဲ့',
      biller: 'ငွေတောင်းခံမှုအဖွဲ့'
    },
    types: {
      request: 'တောင်းဆိုချက်',
      complaint: 'တိုင်ကြားချက်'
    },
    priorities: {
      low: 'နိမ့်',
      medium: 'အလယ်အလတ်',
      high: 'မြင့်',
      urgent: 'အရေးပေါ်'
    },
    totalTickets: 'စုစုပေါင်း',
    resolvedTickets: 'ဖြေရှင်းပြီး',
    closedTickets: 'ပိတ်သိမ်းပြီး',
    averageResponseTime: 'ပြန်ဖြေကြားရန် ပျမ်းမျှကြာချိန်',
    averageResolutionTime: 'ဖြေရှင်းရန် ပျမ်းမျှကြာချိန်',
    columns: {
      id: 'ID',
      title: 'ခေါင်းစဉ်',
      customer: 'ဖောက်သည်',
      status: 'အခြေအနေ',
      priority: 'ဦးစားပေးအဆင့်',
      type: 'အမျိုးအစား',
      category: 'အမျိုးအစား',
      source: 'ရင်းမြစ်',
      assignedTo: 'တာဝန်ပေးထားသူ',
      createdAt: 'ဖန်တီးသည့်အချိန်'
    },
    unassigned: 'တာဝန်မပေးရသေးသော',
    categories: {
      technical: 'နည်းပညာဆိုင်ရာ',
      billing: 'ငွေတောင်းခံမှုဆိုင်ရာ',
      feature: 'လုပ်ဆောင်ချက်',
      account: 'အကောင့်',
      other: 'အခြား'
    },

    bulkActions: {
      changeStatus: 'အခြေအနေပြောင်းရန်',
      confirmTitle: 'အခြေအနေပြောင်းလဲမှုကို အတည်ပြုပါ',
      confirmMessage:
        'လက်မှတ် {{count}} ခု၏ အခြေအနေကို <strong>{{status}}</strong> အဖြစ်သို့ ပြောင်းလဲရန် သေချာပါသလား။ ဤလုပ်ဆောင်ချက်ကို ပြန်လည်ပြင်ဆင်၍မရပါ။',
      confirm: 'အတည်ပြုပါ'
    },
    selected: 'ရွေးချယ်ထားပြီး',
    removeAttachment: 'ဖိုင်ပူးတွဲကို ဖျက်ရန်',
    maxFileSize: 'ဖိုင်တစ်ခုလျှင် အများဆုံး ၅၀MB',
    uploadFile: 'ဖိုင် တင်ရန်',
    dragndrop: ' သို့မဟုတ် ဖိဆွဲ၍ထည့်ပါ'
  },
  // Date and Time
  dateTime: {
    title: 'ရက်စွဲနှင့် အချိန်ဖော်ပြချက်',
    today: 'ယနေ့',
    yesterday: 'မနေ့က',
    tomorrow: 'မနက်ဖြန်',
    now: 'ယခု',
    justNow: 'ယခုလေးတင်',
    minutesAgo: '{{count}} မိနစ်က',
    minutesAgo_plural: '{{count}} မိနစ်က',
    hoursAgo: '{{count}} နာရီက',
    hoursAgo_plural: '{{count}} နာရီက',
    daysAgo: '{{count}} ရက်က',
    daysAgo_plural: '{{count}} ရက်က',
    dateRange: 'ရက်စွဲအပိုင်းအခြား',
    startDate: 'စတင်ရက်',
    endDate: 'ပြီးဆုံးရက်',
    invalidDateRange: 'စတင်ရက်သည် ပြီးဆုံးရက်ထက် စောရမည် သို့မဟုတ် တူညီရမည်',
    timezone: 'အချိန်ဇုန်',
    myanmarTimezone: 'မြန်မာအချိန် (UTC+06:30)',
    dateFormat: 'လလ/ရက်/နှစ်',
    timeFormat: 'နာရီ:မိနစ် AM/PM',
    dateTimeFormat: 'လလ/ရက်/နှစ် နာရီ:မိနစ် AM/PM',
    formats: 'ရက်စွဲပုံစံများ',
    currentDate: 'လက်ရှိရက်စွဲ',
    currentDateTime: 'လက်ရှိရက်စွဲနှင့်အချိန်',
    apiFormat: 'API ပုံစံ',
    parsing: 'ရက်စွဲခွဲခြမ်းစိတ်ဖြာခြင်း',
    parsedDate: 'ခွဲခြမ်းစိတ်ဖြာထားသောရက်စွဲ',
    currentMyanmarTime: 'လက်ရှိ မြန်မာအချိန်',
    systemTime: 'စနစ်အချိန်',
    apiFormats: 'မြန်မာအချိန်ဇုန်ဖြင့် API ရက်စွဲပုံစံများ',
    startOfDay: 'နေ့စတင်ချိန်',
    endOfDay: 'နေ့ဆုံးချိန်',
    startOfDayDesc: 'အချိန်ကို +06:30 အချိန်ဇုန်ဖြင့် 00:00:00 သို့ သတ်မှတ်သည်',
    endOfDayDesc: 'အချိန်ကို +06:30 အချိန်ဇုန်ဖြင့် 23:59:59 သို့ သတ်မှတ်သည်',
    dateRangeExample: 'ရက်စွဲအပိုင်းအခြား ဥပမာ',
    apiRequestExample: 'API တောင်းဆိုမှု ဥပမာ',
    apiDateComment:
      'API တောင်းဆိုမှုများအတွက် မြန်မာအချိန်ဇုန် (UTC+06:30) ကို အတိအလင်း သတ်မှတ်ထားသည်',
    rawFormats: 'မူလရက်စွဲပုံစံ နှိုင်းယှဉ်ချက်',
    formattedWithUtils: 'ကျွန်ုပ်တို့၏ utility များဖြင့် ပုံစံပြင်ထားသည်',
    apiFormatted: 'API ပုံစံပြင်ထားသည် (မြန်မာအချိန်ဇုန်)',
    filterStartHint: 'စတင်: မနက် 12:00 AM',
    filterEndHint: 'ပြီးဆုံး: ည 11:59 PM'
  },
  // Profile
  profile: {
    uploadPicture: 'ပရိုဖိုင်ဓာတ်ပုံ တင်ရန်',
    selectImageFile: 'ဓာတ်ပုံဖိုင်ကို ရွေးချယ်ပါ',
    imageSizeLimit: 'ဓာတ်ပုံအရွယ်အစားသည် 5MB အောက်ဖြစ်ရမည်',
    uploadSuccess: 'ပရိုဖိုင်ဓာတ်ပုံ အောင်မြင်စွာ တင်ပြီးပါပြီ',
    uploadFailed: 'ပရိုဖိုင်ဓာတ်ပုံ တင်ရန် မအောင်မြင်ပါ',
    changePassword: 'စကားဝှက် ပြောင်းလဲရန်',
    personalInfo: 'ကိုယ်ရေးအချက်အလက်',
    updateProfile: 'ပရိုဖိုင် ပြင်ဆင်ရန်',
    fullName: 'အမည်အပြည့်အစုံ',
    email: 'အီးမေးလ်',
    role: 'အခန်းကဏ္ဍ',
    lastLogin: 'နောက်ဆုံးဝင်ရောက်မှု',
    joinedOn: 'စတင်ဝင်ရောက်သည့်ရက်စွဲ'
  },
  // Metadata
  metadata: {
    addNew: 'အသစ်ထည့်ရန်',
    edit: 'ပြင်ဆင်ရန်',
    save: 'သိမ်းဆည်းရန်',
    create: 'ဖန်တီးရန်',
    delete: 'ဖျက်ရန်',
    name: 'အမည်',
    description: 'ဖော်ပြချက်',
    actions: 'လုပ်ဆောင်ချက်များ',
    confirmDelete: 'ဖျက်ရန် အတည်ပြုပါ',
    deleteConfirmation:
      '{{name}} ကို ဖျက်ရန် သေချာပါသလား? ဤလုပ်ဆောင်ချက်ကို ပြန်လည်ပြုပြင်မရနိုင်ပါ။',
    failedToFetch: 'အချက်အလက်များကို ရယူရန် မအောင်မြင်ပါ',
    failedToSave: 'အချက်အလက်ကို သိမ်းဆည်းရန် မအောင်မြင်ပါ',
    failedToDelete: 'အချက်အလက်ကို ဖျက်ရန် မအောင်မြင်ပါ'
  },
  // Settings
  // Page titles and headers
  pageHeaders: {
    dashboard: {
      title: 'ဒက်ရှ်ဘုတ်',
      enhancedTitle: 'အဆင့်မြင့် ဒက်ရှ်ဘုတ်',
      enhancedSubtitle:
        'သင့်တောင်းဆိုချက်များအတွက် အဆင့်မြင့် ခွဲခြမ်းစိတ်ဖြာမှုများနှင့် အမြင်များ',
      topContributors: 'ထိပ်တန်း ပံ့ပိုးသူများ',
      failedToLoadContributors: 'ထိပ်တန်း ပံ့ပိုးသူများကို ရယူရန် မအောင်မြင်ပါ',
      failedToLoadTicketTrends: 'တောင်းဆိုချက်လမ်းကြောင်းများကို ရယူရန် မအောင်မြင်ပါ',
      failedToLoadTrends: 'တောင်းဆိုချက်လမ်းကြောင်းများကို ရယူရန် မအောင်မြင်ပါ',
      failedToLoadStats: 'ဒက်ရှ်ဘုတ်အချက်အလက်များကို ရယူရန် မအောင်မြင်ပါ',
      createdTickets: 'ဖန်တီးခဲ့သော တောင်းဆိုချက်များ',
      closedTickets: 'ပိတ်ထားသော တောင်းဆိုချက်များ',
      tickets: 'တောင်းဆိုချက်များ',
      overview: 'အကျဉ်းချုပ်',
      quickStats: 'အမြန်အချက်အလက်များ',
      ticketBreakdown: 'တောင်းဆိုချက်အကျဉ်း',
      recentActivity: 'လတ်တလော လုပ်ဆောင်ချက်များ',
      // Enhanced Dashboard
      ticketTrends: 'တောင်းဆိုချက်လမ်းကြောင်းများ',
      trendsDescription: 'နေ့စဉ် တောင်းဆိုချက်ဖန်တီးမှုနှင့် ဖြေရှင်းမှုပုံစံများ',
      statusBreakdown: 'အခြေအနေအကွဲ',
      statusDescription: 'လက်ရှိအခြေအနေအလိုက် တောင်းဆိုချက်များ ခွဲဝေမှု',
      priorityDistribution: 'ဦးစားပေးအဆင့် ခွဲဝေမှု',
      priorityDescription: 'ဦးစားပေးအဆင့်အလိုက် တောင်းဆိုချက်များ ခွဲခြမ်းမှု',
      contributorsDescription: 'ဖြေရှင်းထားသော တောင်းဆိုချက်များအလိုက် အသက်ဝင်ဆုံး အဖွဲ့ဝင်များ',
      ticketsCreated: 'ဖန်တီးထားသော တောင်းဆိုချက်များ',
      ticketsClosed: 'ပိတ်ထားသော တောင်းဆိုချက်များ',
      netChange: 'စုစုပေါင်း ပြောင်းလဲမှု',
      efficiency: 'ထိရောက်မှု',
      totalCreated: 'စုစုပေါင်း ဖန်တီးမှု',
      totalClosed: 'စုစုပေါင်း ပိတ်မှု',
      backlogIncreased: 'လုပ်ငန်းစာရင်း တိုးလာသည်',
      backlogDecreased: 'လုပ်ငန်းစာရင်း လျော့လာသည်',
      backlogStable: 'လုပ်ငန်းစာရင်း တည်ငြိမ်သည်',
      noTrendData: 'ရွေးချယ်ထားသော ရက်စွဲအပိုင်းအခြားအတွက် လမ်းကြောင်းအချက်အလက် မရှိပါ',
      totalTickets: 'စုစုပေါင်း တောင်းဆိုချက်များ',
      quickInsights: 'အမြန်အမြင်များ',
      newTicketsNeedAttention: 'တောင်းဆိုချက်အသစ်များ အာရုံစိုက်ရန်လိုသည်',
      ticketsInProgress: 'လက်ရှိ လုပ်ဆောင်နေသော တောင်းဆိုချက်များ',
      ticketsAwaitingClosure: 'ပိတ်ရန်စောင့်နေသော တောင်းဆိုချက်များ',
      ticketCount: 'တောင်းဆိုချက်အရေအတွက်',
      averagePriority: 'ပျမ်းမျှ ဦးစားပေးအမှတ်',
      priorityScoreDesc: 'အလေးချိန်ပေးထားသော ပျမ်းမျှ (၁=နိမ့်, ၄=အရေးကြီး)',
      urgentAttention: 'အရေးကြီး အာရုံစိုက်ရန်လိုသည်',
      urgentTicketsMessage: 'အရေးကြီး တောင်းဆိုချက်များ ချက်ချင်းအာရုံစိုက်ရန်လိုသည်',
      // Performance Metrics
      completionRate: 'ပြီးမြောက်မှုနှုန်း',
      ticketsCompleted: 'ပြီးမြောက်ထားသော တောင်းဆိုချက်များ',
      avgResponseTime: 'ပျမ်းမျှ တုံ့ပြန်ချိန်',
      averageFirstResponse: 'ပျမ်းမျှ ပထမတုံ့ပြန်မှု',
      activeTickets: 'လုပ်ဆောင်နေသော တောင်းဆိုချက်များ',
      newAndProcessing: 'အသစ်နှင့် လုပ်ဆောင်နေသော',
      performanceSummary: 'စွမ်းဆောင်ရည်အကျဉ်းချုပ်',
      workloadDistribution: 'အလုပ်ဝန်ခွဲဝေမှု',
      newTickets: 'အသစ်',
      processing: 'လုပ်ဆောင်နေသော',
      resolved: 'ဖြေရှင်းပြီး',
      priorityBreakdown: 'ဦးစားပေးအဆင့် ခွဲခြမ်းမှု',
      urgent: 'အရေးကြီး',
      high: 'မြင့်',
      medium: 'အလယ်အလတ်',
      keyInsights: 'အဓိကအမြင်များ',
      excellentCompletion: 'အလွန်ကောင်းသော ပြီးမြောက်မှုနှုန်း',
      noUrgentTickets: 'အရေးကြီး တောင်းဆိုချက်များ မရှိပါ',
      managableWorkload: 'စီမံနိုင်သော အလုပ်ဝန်',
      active: 'လုပ်ဆောင်နေသော',
      // Top Contributors
      progress: 'တိုးတက်မှု',
      inProgress: 'လုပ်ဆောင်နေသော',
      total: 'စုစုပေါင်း',
      noContributorsData: 'ရွေးချယ်ထားသော ရက်စွဲအပိုင်းအခြားအတွက် ပံ့ပိုးသူအချက်အလက် မရှိပါ',
      teamSummary: 'အဖွဲ့အကျဉ်းချုပ်',
      totalResolved: 'စုစုပေါင်း ဖြေရှင်းပြီး',
      totalInProgress: 'စုစုပေါင်း လုပ်ဆောင်နေသော',
      topPerformer: 'ထိပ်တန်း စွမ်းဆောင်သူ',
      errorTitle: 'ဒက်ရှ်ဘုတ် ရယူရန် အမှားရှိသည်',
      searchError: 'ရွေးလဲမှု အမှား',
      separator: '•',
      allTimeTotal: 'အချက်အမြေား စုစုပေါင်း',
      dayAverage: '/နေ့ ပျမ်းမျှ',
      backlogGrew: 'အလုပ်စာရင်း တိုးလာသည်',
      backlogShrank: 'အလုပ်စာရင်း လျော့လာသည်',
      stable: 'တည်ငြိမ်',
      resolutionRate: 'ဖြေရှင်းမှုနှုန်း'
    },
    tickets: {
      title: 'တောင်းဆိုချက်များ',
      allTickets: 'တောင်းဆိုချက်အားလုံး',
      viewMode: 'ကြည့်ရှုပုံစံ',
      list: 'စာရင်း',
      table: 'ဇယား',
      kanban: 'ကန်ဘန်',
      filterTickets: 'တောင်းဆိုချက်များ စီစစ်ရန်',
      ticketDetails: 'တောင်းဆိုချက်အသေးစိတ်',
      view: 'ကြည့်ရှုရန်',
      tableView: 'ဇယားပုံစံ',
      listView: 'စာရင်းပုံစံ',
      kanbanView: 'ကန်ဘန်ပုံစံ',
      totalTickets: 'စုစုပေါင်း တောင်းဆိုချက်များ',
      allStatuses: 'အခြေအနေအားလုံး',
      requestedBy: 'တောင်းဆိုသူ',
      assignedTo: 'တာဝန်ပေးထားသူ',
      filterByGroups: 'အုပ်စုအဖွဲ့များဖြင့် စစ်ထုတ်ရန်...',
      filterByRequesters: 'တောင်းဆိုသူများဖြင့် စစ်ထုတ်ရန်...',
      filterByAssignees: 'တာဝန်ပေးထားသူများဖြင့် စစ်ထုတ်ရန်...',
      hideFilters: 'စစ်ထုတ်မှုများ ဖျောက်ရန်',
      showFilters: 'စစ်ထုတ်မှုများ ပြရန်',
      noTicketsFound: 'တောင်းဆိုချက်များ မတွေ့ရှိပါ',
      kanbanBoard: {
        dragToReorder: 'အစီအစဉ်ပြန်လုပ်ရန် ဆွဲရန်',
        private: 'သီးသန့်',
        createdBy: 'ဖန်တီးသူ:',
        assignedTo: 'တာဝန်ပေးထားသူ:',
        created: 'ဖန်တီးသည်',
        updated: 'ပြင်ဆင်သည်'
      }
    },
    createTicket: {
      title: 'တောင်းဆိုချက်အသစ် ဖန်တီးရန်',
      newTicket: 'တောင်းဆိုချက်အသစ်',
      basicInfo: 'အခြေခံအချက်အလက်',
      additionalDetails: 'အခြားအသေးစိတ်အချက်အလက်များ',
      error: 'တောင်းဆိုချက် ဖန်တီးရန် မအောင်မြင်ပါ',
      createButton: 'တောင်းဆိုချက် ဖန်တီးရန်',
      fields: {
        title: 'တောင်းဆိုချက်ခေါင်းစဉ်',
        titlePlaceholder: 'ပြဿနာ၏ အကျဉ်းချုပ်ဖော်ပြချက်',
        source: 'အရင်းအမြစ်',
        category: 'အမျိုးအစား',
        type: 'ပုံစံ',
        assignToGroup: 'အဖွဲ့သို့ တာဝန်ပေးရန်',
        assignToAgent: 'အေးဂျင့်သို့ တာဝန်ပေးရန်',
        tags: 'တဂ်များ',
        tagsPlaceholder: 'တဂ်များ ရွေးချယ် သို့မဟုတ် ရှာဖွေရန်...',
        noTagsAvailable: 'တဂ်များ မရှိပါ',
        typeAtLeastOneChar: 'အနည်းဆုံး စာလုံး ၁ လုံး ရိုက်ထည့်ပါ',
        noMatchingTags: 'ကိုက်ညီသော တဂ်များ မရှိပါ',
        loadingTags: 'တဂ်များ ဖတ်ယူနေသည်...',
        ticketDetails: 'တောင်းဆိုချက် အသေးစိတ်',
        description: 'ဖော်ပြချက်',
        descriptionPlaceholder: 'ပြဿနာ၏ အသေးစိတ်ဖော်ပြချက်...',
        templates: 'ပုံစံများ',
        selectTemplate: 'ပုံစံတစ်ခု ရွေးချယ်ပါ',
        loadingTemplates: 'ပုံစံများ ဖတ်ယူနေသည်...',
        notifyCustomer: 'ဖောက်သည်ကို အကြောင်းကြားရန်',
        notifyCustomerDescription: 'တောင်းဆိုချက်အကြောင်း ဖောက်သည်ကို ချက်ချင်းအကြောင်းကြားရန်'
      }
    },
    reports: {
      title: 'အစီရင်ခံစာများ',
      ticketStats: 'တောင်းဆိုချက်အချက်အလက်များ',
      exportData: 'အချက်အလက်ထုတ်ယူရန်',
      dateRangeReport: 'ရက်စွဲအပိုင်းအခြား အစီရင်ခံစာ',
      ticketsExport: 'တောင်းဆိုချက်များ',
      exporting: 'ထုတ်ယူနေသည်...',
      export: 'ထုတ်ယူရန်'
    },
    settings: {
      title: 'ဆက်တင်များ',
      account: 'အကောင့်',
      preferences: 'ကြိုက်နှစ်သက်မှုများ',
      notifications: 'အသိပေးချက်များ',
      security: 'လုံခြုံရေး'
    },
    myMemo: {
      title: 'ကျွန်ုပ်၏ မှတ်စုများ',
      createMemo: 'မှတ်စု အသစ်ဖန်တီးရန်',
      editMemo: 'မှတ်စု ပြင်ဆင်ရန်',
      deleteMemo: 'မှတ်စု ဖျက်ရန်',
      newMemo: 'မှတ်စုအသစ်',
      arrangeInGrid: 'ဇယားပုံစံ စီစဉ်ရန်',
      loadError: 'မှတ်စုများ ဖတ်ယူရန် မအောင်မြင်ပါ',
      createError: 'မှတ်စုအသစ် ဖန်တီးရန် မအောင်မြင်ပါ',
      updateError: 'မှတ်စု ပြင်ဆင်ရန် မအောင်မြင်ပါ',
      deleteError: 'မှတ်စု ဖျက်ရန် မအောင်မြင်ပါ',
      loginRequired: 'သင့်မှတ်စုများကို ကြည့်ရှုရန် ကျေးဇူးပြု၍ အကောင့်ဝင်ပါ',
      searchPlaceholder: 'မှတ်စုများ ရှာဖွေရန်...',
      memoCount: 'မှတ်စု {{count}} ခု',
      noMemos: 'မှတ်စုများ မရှိသေးပါ',
      noMatchingMemos: 'ကိုက်ညီသော မှတ်စုများ မရှိပါ',
      tryDifferentSearch: 'အခြားရှာဖွေမှု စကားလုံးကို သုံးကြည့်ပါ',
      createFirstMemo: 'စတင်ရန် သင့်ပထမဆုံး မှတ်စုကို ဖန်တီးပါ',
      createNewMemo: 'မှတ်စုအသစ် ဖန်တီးရန်'
    },
    changePassword: {
      title: 'စကားဝှက် ပြောင်းလဲရန်',
      currentPassword: 'လက်ရှိစကားဝှက်',
      newPassword: 'စကားဝှက်အသစ်',
      confirmPassword: 'စကားဝှက်အတည်ပြုရန်',
      success: 'စကားဝှက် အောင်မြင်စွာ ပြောင်းလဲပြီးပါပြီ',
      failedToChange: 'စကားဝှက် ပြောင်းလဲရန် မအောင်မြင်ပါ',
      validation: {
        currentRequired: 'လက်ရှိစကားဝှက် လိုအပ်ပါသည်',
        minLength: 'စကားဝှက်အသစ်သည် အနည်းဆုံး စာလုံး ၆ လုံး ရှိရပါမည်',
        maxLength: 'စကားဝှက်အသစ်သည် စာလုံး ၅၀ ထက် မပိုရပါ',
        confirmRequired: 'ကျေးဇူးပြု၍ သင့်စကားဝှက်အသစ်ကို အတည်ပြုပါ',
        passwordsDontMatch: 'စကားဝှက်များ မတူညီပါ'
      }
    },
    contact: {
      title: 'ဆက်သွယ်ရန်',
      contactForm: 'ဆက်သွယ်ရန်ပုံစံ',
      sendMessage: 'စာပို့ရန်',
      contactInfo: 'ဆက်သွယ်ရန်အချက်အလက်',
      subtitle: 'ကျွန်ုပ်တို့အဖွဲ့နှင့် ဆက်သွယ်ပါ',
      officeHours: 'ရုံးချိန်',
      headquarters: 'ရုံးချုပ်'
    },
    privacyPolicy: {
      title: 'ကိုယ်ရေးကိုယ်တာ မူဝါဒ'
    },
    termsOfService: {
      title: 'ဝန်ဆောင်မှု စည်းကမ်းချက်များ'
    },
    landing: {
      title: 'FlowCXP - ဖောက်သည်အတွေ့အကြုံ ပလက်ဖောင်း',
      subtitle:
        'ကျွန်ုပ်တို့၏ ခေတ်မီတောင်းဆိုချက်စနစ်ဖြင့် သင့်ဖောက်သည်ဝန်ဆောင်မှုကို ပိုမိုကောင်းမွန်စေပါ',
      nav: {
        signIn: 'အကောင့်ဝင်ရန်',
        getStarted: 'စတင်လိုက်ပါ'
      },
      hero: {
        transparentPricing: 'အေဂျင့်တစ်ယောက်လျှင် $15-20 ဖြင့် ပွင့်လင်းသော စျေးနှုန်း',
        premiumFeatures: 'အဆင့်မြင့်လုပ်ဆောင်ချက်အားလုံး ပါဝင်သည်',
        exceptionalValue: 'မည်သည့်အရွယ်အစားရှိသော အဖွဲ့များအတွက် ထူးခြားသောတန်ဖိုး',
        modernInterface: 'လျှပ်စစ်ခေတ်မီ React အသွင်အပြင်',
        realtimeUpdates: 'အချိန်နှင့်တစ်ပြေးညီ အပ်ဒိတ်များနှင့် အကြောင်းကြားချက်များ',
        boostProductivity: 'အဖွဲ့၏ထုတ်လုပ်မှုကို 40% တိုးမြှင့်စေပါသည်',
        comprehensiveFeatures: 'ပြည့်စုံသော လုပ်ဆောင်ချက်များ',
        everyFeature: 'အစီအစဉ်တိုင်းတွင် လုပ်ဆောင်ချက်အားလုံး ပါဝင်သည်',
        predictablePricing: 'ကြိုတင်မှန်းဆနိုင်သော စျေးနှုန်း၊ အံ့ဧသမှုမရှိ',
        startTrial: '14 ရက် အခမ့်စမ်းသပ်ကို စတင်ပါ',
        noCreditCard: 'ခရက်ဒစ်ကတ် မလိုပါ။ လုပ်ဆောင်ချက်အားလုံးကို ရယူအသုံးပြုနိုင်သည်။'
      },
      featuresTitle: 'ခေတ်မီဝန်ဆောင်မှုအဖွဲ့များအတွက် ဒီဇိုင်းဆွဲထားသည်',
      features: {
        dashboard: {
          name: 'အသုံးပြုရလွယ်ကူသော ဒက်ရှ်ဘုတ်',
          description:
            'ကျွန်ုပ်တို့၏ စိတ်ကြိုက်ပြင်ဆင်နိုင်သော ဒက်ရှ်ဘုတ်ဖြင့် သင့်ဝန်ဆောင်မှုလုပ်ငန်းများအားလုံးကို ခြုံငုံကြည့်ရှုနိုင်ပါသည်။',
          alt: 'တောင်းဆိုချက်စာရင်းအင်းနှင့် လုပ်ဆောင်မှုများပြသသော ဒက်ရှ်ဘုတ်အသွင်အပြင်'
        },
        views: {
          name: 'ပြောင်းလွယ်ပြင်လွယ်သော မြင်ကွင်းများ',
          description:
            'သင်လိုအပ်သလို စီမံခန့်ခွဲနိုင်ရန် ကန်ဘန်၊ ဇယား၊ နှင့် ကတ်ပြားမြင်ကွင်းများကြား ပြောင်းလဲကြည့်ရှုနိုင်ပါသည်။',
          alt: 'တောင်းဆိုချက်များ၏ ကန်ဘန်ဘုတ်မြင်ကွင်း'
        },
        ticketManagement: {
          name: 'အသေးစိတ်တောင်းဆိုချက်စီမံခန့်ခွဲမှု',
          description:
            'ကျွန်ုပ်တို့၏ ပြည့်စုံသော တောင်းဆိုချက်မြင်ကွင်းဖြင့် တောင်းဆိုချက်အသေးစိတ်အားလုံးကို တစ်နေရာတည်းတွင် ကြည့်ရှုနိုင်ပါသည်။',
          alt: 'အချက်အလက်အပြည့်အစုံပါဝင်သော အသေးစိတ်တောင်းဆိုချက်မြင်ကွင်း'
        },
        reporting: {
          name: 'အဆင့်မြင့်အစီရင်ခံစာများ',
          description:
            'စွမ်းဆောင်ရည်ကို ခြေရာခံရန်နှင့် လမ်းကြောင်းများကို ဖော်ထုတ်ရန် အသိဉာဏ်ပါသော အစီရင်ခံစာများကို ထုတ်ယူနိုင်ပါသည်။',
          alt: 'ဇယားများနှင့် တိုင်းတာမှုများပါဝင်သော အစီရင်ခံစာအသွင်အပြင်'
        }
      },
      platformHighlights: 'ပလက်ဖောင်းအထူးအချက်များ',
      pricing: {
        title: 'သင့်စီးပွားရေးလုပ်ငန်းအတွက် စိတ်ကြိုက်ဖြေရှင်းချက်များ',
        description:
          'FlowCXP လုပ်ဆောင်ချက်အားလုံး—တောင်းဆိုချက်၊ လုပ်ငန်းစဉ်များ၊ အချက်အလက်စိစစ်ခြင်း၊ ပေါင်းစပ်မှုများ—သင့်အဖွဲ့အစည်းနှင့်အတူ တိုးတက်ရန် ဒီဇိုင်းဆွဲထားသည်။',
        period: 'စျေးနှုန်း',
        enterprise: {
          name: 'စီးပွားရေးလုပ်ငန်းကြီး',
          price: 'စိတ်ကြိုက်',
          description:
            'အရွယ်အစားအမျိုးမျိုးရှိသော စီးပွားရေးလုပ်ငန်းများအတွက် စိတ်ကြိုက်စျေးနှုန်း၊ SLA များ၊ နှင့် ဖြန့်ချိရေးရွေးချယ်စရာများ။',
          seatLimit: 'မည်သည့်အဖွဲ့အရွယ်အစားမဆို',
          cta: 'သရုပ်ပြမှုတောင်းဆိုရန်',
          features: {
            all: 'FlowCXP လုပ်ဆောင်ချက်အားလုံး ပါဝင်သည်',
            ticketing: 'ပြည့်စုံသော တောင်းဆိုချက်စနစ်',
            workflows: 'အကန့်အသတ်မရှိ လုပ်ငန်းစဉ်များနှင့် အလိုအလျောက်လုပ်ဆောင်မှုများ',
            sla: 'စိတ်ကြိုက် SLA များနှင့် ဖြန့်ချိရေးရွေးချယ်စရာများ',
            accountManager: 'သီးသန့်အကောင့်မန်နေဂျာ',
            prioritySupport: 'ဦးစားပေးပံ့ပိုးမှု',
            integrations: 'စိတ်ကြိုက်ပေါင်းစပ်မှုများ'
          }
        }
      },
      forgotPassword: 'စကားဝှက်မေ့သွားပါသလား'
    },
    login: {
      title: 'အကောင့်ဝင်ရန်',
      welcome: 'ကြိုဆိုပါသည်',
      credentials: 'သင့်အချက်အလက်များဖြင့် ဝင်ရောက်ပါ',
      forgotPassword: 'စကားဝှက်မေ့သွားပါသလား'
    },
    registration: {
      title: 'အကောင့်ဖွင့်ရန်',
      createAccount: 'အကောင့်အသစ်ဖွင့်ရန်',
      alreadyHaveAccount: 'အကောင့်ရှိပြီးသားလား'
    },
    checkout: {
      title: 'ငွေပေးချေရန်',
      paymentDetails: 'ငွေပေးချေမှုအသေးစိတ်',
      billingInfo: 'ငွေတောင်းခံမှုအချက်အလက်',
      invalidPlan: 'မမှန်ကန်သော အစီအစဉ် ရွေးချယ်ထားပါသည်',
      planNotFound: 'အစီအစဉ် ရှာမတွေ့ပါ',
      backToPricing: 'စျေးနှုန်းများသို့ ပြန်သွားရန်',
      subscribingTo: '{{planName}} အစီအစဉ်ကို စာရင်းသွင်းနေသည်'
    },
    paymentSuccess: {
      title: 'ငွေပေးချေမှု အောင်မြင်ပါသည်',
      thankYou: 'ဝယ်ယူမှုအတွက် ကျေးဇူးတင်ပါသည်',
      orderDetails: 'အော်ဒါအသေးစိတ်'
    }
  },
  // Search
  search: {
    placeholder: 'တောင်းဆိုချက်များကို ရှာဖွေရန်... (ဥပမာ @ticket_id: 123)',
    criteria: {
      ticketId: 'တောင်းဆိုချက် ID',
      ticketTitle: 'တောင်းဆိုချက်ခေါင်းစဉ်',
      ticketDescription: 'တောင်းဆိုချက်ဖော်ပြချက်',
      customerId: 'ဆေးခ်ဖြစ်သူ ID',
      customerName: 'ဆေးခ်ဖြစ်သူအမည်',
      customerPhone: 'ဆေးခ်ဖြစ်သူဖုန်းနံပါတ်',
      customerReference: 'ဆေးခ်ဖြစ်သူကိုးကားချက်'
    }
  },
  settings: {
    manageAgents: 'အေးဂျင့်များကို စီမံခန့်ခွဲရန်',
    availableAgents: 'ရရှိနိုင်သော အေးဂျင့်များ',
    currentAgents: 'လက်ရှိ အေးဂျင့်များ',
    addSelected: 'ရွေးချယ်ထားသည်များကို ထည့်သွင်းရန်',
    removeSelected: 'ရွေးချယ်ထားသည်များကို ဖယ်ရှားရန်',
    failedToLoadAgents: 'အေးဂျင့်များကို ဖတ်ယူရန် မအောင်မြင်ပါ',
    failedToAddAgents: 'အေးဂျင့်များကို ထည့်သွင်းရန် မအောင်မြင်ပါ',
    failedToRemoveAgents: 'အေးဂျင့်များကို ဖယ်ရှားရန် မအောင်မြင်ပါ',
    title: 'ဆက်တင်များ',
    sources: 'အရင်းအမြစ်များ',
    categories: 'အမျိုးအစားများ',
    types: 'အမျိုးအစားခွဲများ',
    agents: 'အေးဂျင့်များ',
    groups: 'အုပ်စုများ',
    tags: 'တဂ်များ',
    templates: 'ပုံစံများ',
    integrations: 'ပေါင်းစည်းမှုများ',
    botConfiguration: 'ဘော့သတ်မှတ်ချက်',
    billing: 'ငွေပေးချေမှု',
    auditLogs: 'စစ်ဆေးမှုမှတ်တမ်းများ',
    accessDenied: 'သင့်တွင် ဆက်တင်များကို ကြည့်ရှုခွင့် မရှိပါ။ သင့်စီမံခန့်ခွဲသူကို ဆက်သွယ်ပါ။',
    billingAccessDenied:
      'သင့်တွင် ငွေပေးချေမှုဆက်တင်များကို ဝင်ရောက်ခွင့် မရှိပါ။ ဤလုပ်ဆောင်ချက်သည် အဆင့်မြင့်စီမံခန့်ခွဲသူအခွင့်အရေးများ လိုအပ်ပါသည်။',
    userManagement: {
      title: 'အေးဂျင့်များ',
      description: 'တစ်ကတ်များကို ကိုင်တွယ်နိုင်သော အေးဂျင့်များကို စီမံခန့်ခွဲရန်',
      addNew: 'အသစ်ထည့်ရန်',
      me: 'ကျွန်ုပ်',
      resetPassword: 'စကားဝှက် ပြန်လည်သတ်မှတ်ရန်',
      cannotDeleteOwnAccount: 'သင်၏ကိုယ်ပိုင်အကောင့်ကို မဖျက်နိုင်ပါ',
      deleteAgent: 'အေးဂျင့်ကို ဖျက်ရန်',
      confirmDelete: 'ဖျက်ရန် သေချာပါသလား',
      tempPasswordGenerated: 'ယာယီစကားဝှက် ထုတ်ပေးပြီး',
      resetPasswordTitle: 'စကားဝှက် ပြန်လည်သတ်မှတ်ရန်',
      confirmResetPassword: 'စကားဝှက်ပြန်လည်သတ်မှတ်ရန် သေချာပါသလား',
      tempPasswordMessage: 'ယာယီစကားဝှက်ကို ထုတ်ပေးပြီးပါပြီ',
      copyToClipboard: 'ကလစ်ဘုတ်သို့ ကူးယူရန်',
      editAgent: 'ပြင်ဆင်ရန်',
      addAgent: 'ထည့်ရန်',
      fullName: 'အမည်အပြည့်အစုံ',
      phone: 'ဖုန်းနံပါတ်',
      email: 'အီးမေးလ်',
      password: 'စကားဝှက်',
      role: 'အခန်းကဏ္ဍ',
      totalAgents: 'အေးဂျင့်စုစုပေါင်း',
      roles: {
        agent: 'အေးဂျင့်',
        admin: 'အက်ဒမင်',
        requester: 'တောင်းဆိုသူ'
      },
      saveChanges: 'ပြောင်းလဲမှုများ သိမ်းဆည်းရန်',
      create: 'ဖန်တီးရန်',
      columns: {
        name: 'အမည်',
        phone: 'ဖုန်းနံပါတ်',
        email: 'အီးမေးလ်',
        role: 'အခန်းကဏ္ဍ',
        actions: 'လုပ်ဆောင်ချက်များ'
      },
      errors: {
        fetchFailed: 'အသုံးပြုသူများ ရယူရန် မအောင်မြင်ပါ',
        saveFailed: 'အသုံးပြုသူ သိမ်းဆည်းရန် မအောင်မြင်ပါ',
        deleteFailed: 'အသုံးပြုသူ ဖျက်ရန် မအောင်မြင်ပါ'
      },
      success: {
        userSaved: 'အသုံးပြုသူ အောင်မြင်စွာ သိမ်းဆည်းပြီး',
        userDeleted: 'အသုံးပြုသူကို အောင်မြင်စွာ ဖျက်ပြီး'
      }
    },
    sourceManagement: {
      title: 'ရင်းမြစ်များ',
      description:
        'တစ်ကတ်များ ဖန်တီးနိုင်သည့် ရင်းမြစ်များနှင့် ဆက်သွယ်မှုလမ်းကြောင်းများကို စီမံခန့်ခွဲရန်'
    },
    categoryManagement: {
      title: 'အမျိုးအစားများ',
      description: 'တစ်ကတ်များကို အမျိုးအစားခွဲများကို စီမံခန့်ခွဲရန်'
    },
    typeManagement: {
      title: 'အမျိုးအစားခွဲများ',
      description: 'တစ်ကတ်အမျိုးအစားခွဲများကို စီမံခန့်ခွဲရန်'
    },
    groupManagement: {
      title: 'အဖွဲ့များ',
      description: 'ပံ့ပိုးမှုအဖွဲ့များနှင့် အဖွဲ့တာဝန်ခွဲဝေမှုများကို စီမံခန့်ခွဲရန်'
    },
    tagManagement: {
      title: 'တဂ်များ',
      description:
        'တစ်ကတ်များကို ပိုမိုကောင်းမွန်စွာ စီစဉ်ရန်နှင့် စစ်ထုတ်ရန် တဂ်များကို စီမံခန့်ခွဲရန်',
      titleSuggestions: 'ခေါင်းစဉ် အကြံပြုချက်များ',
      addTitleSuggestion: 'ခေါင်းစဉ် အကြံပြုချက် ထည့်ရန်',
      editTitleSuggestion: 'ခေါင်းစဉ် အကြံပြုချက် ပြင်ဆင်ရန်',
      deleteTitleSuggestion: 'ခေါင်းစဉ် အကြံပြုချက် ဖျက်ရန်',
      titleSuggestionPlaceholder: 'ဤတဂ်အတွက် အကြံပြုထားသော ခေါင်းစဉ် ရိုက်ထည့်ပါ',
      noTitleSuggestions: 'ခေါင်းစဉ် အကြံပြုချက်များ မရှိသေးပါ',
      titleSuggestionsDescription: 'ဤတဂ်အတွက် အကြံပြုထားသော တစ်ကတ် ခေါင်းစဉ်များ ထည့်ပါ',
      usageCount: '{{count}} ကြိမ် အသုံးပြုခဲ့သည်',
      confirmDeleteTitle: 'ဤခေါင်းစဉ် အကြံပြုချက်ကို ဖျက်ရန် သေချာပါသလား?',
      titleAdded: 'ခေါင်းစဉ် အကြံပြုချက် ထည့်ပြီးပါပြီ',
      titleDeleted: 'ခေါင်းစဉ် အကြံပြုချက် ဖျက်ပြီးပါပြီ',
      titleLoadError: 'ခေါင်းစဉ် အကြံပြုချက်များ ဖတ်ရန် မအောင်မြင်ပါ',
      titleAddError: 'ခေါင်းစဉ် အကြံပြုချက် ထည့်ရန် မအောင်မြင်ပါ',
      titleDeleteError: 'ခေါင်းစဉ် အကြံပြုချက် ဖျက်ရန် မအောင်မြင်ပါ',
      invalidTitleFormat: 'ခေါင်းစဉ်တွင် မမှန်ကန်သော စာလုံးများ သို့မဟုတ် HTML တဂ်များ ပါဝင်နေသည်'
    },
    ticketTitleSuggestions: {
      title: 'အကြံပြုချက်များ',
      description: 'ရွေးချယ်ထားသော တဂ်များအပေါ် အခြေခံအကြံပြုချက်များအလိုအလျောက်ဖန်တီးရန်',
      enableFeature: 'ခေါင်းစဉ်အကြံပြုချက်များ ဖွင့်ရန်',
      enableDescription:
        'ဖွင့်ထားလျှင် အသုံးပြုသူများသည် တစ်ကတ်ဖန်တီးစဉ်က ရွေးချယ်ထားသော တဂ်များအပေါ် အခြေခံအကြံပြုထားသော ခေါင်းစဉ်များကို မြင်ရမည်',
      manageSuggestions: 'အကြံပြုချက်များ စီမံခန့်ခွဲရန်',
      manageSuggestionsDescription:
        'တဂ် ဆက်တင်များတွင် တဂ်တစ်ခုစီအတွက် ခေါင်းစဉ်အကြံပြုချက်များ ထည့်သွင်းစီမံခန့်ခွဲရန်',
      noSuggestionsAvailable: 'ရွေးချယ်ထားသော တဂ်များအတွက် အကြံပြုချက် မရှိပါ',
      selectFromSuggestions: 'အကြံပြုချက်များမှ ရွေးချယ်ပါ သို့မဟုတ် ကိုယ်တိုင် ရိုက်ထည့်ပါ',
      suggestedTitles: 'အကြံပြုထားသော ခေါင်းစဉ်များ',
      enterManually: 'သို့မဟုတ် ခေါင်းစဉ်ကို ကိုယ်တိုင် ရိုက်ထည့်ပါ',
      autoGenerated: 'ရွေးချယ်ထားသော တဂ် များအပေါ်အခြေခံပြီး ခေါင်းစဉ်ကို အလိုအလျောက်ဖန်တီးပေးသည်',
      settingsSaved: 'တစ်ကတ် ခေါင်းစဉ်အကြံပြုချက် ဆက်တင်များ သိမ်းပြီးပါပြီ',
      settingsError: 'ဆက်တင်များ သိမ်းရန် အမှားအယွင်း ဖြစ်သည်',
      autoTitleToggle: 'ခေါင်းစဉ် အလိုအလျောက်ဖန်တီးခြင်း',
      autoTitleDescription:
        'ရွေးချယ်ထားသော တဂ်များအပေါ် အခြေခံပြီး တစ်ကတ် ခေါင်းစဉ်ကို အလိုအလျောက် ဖြည့်သွင်းပေးသည်'
    },
    templateManagement: {
      title: 'ပုံစံများ',
      description: 'တစ်ကတ်ဖန်တီးခြင်းအတွက် ပုံစံများကို စီမံခန့်ခွဲရန်'
    },
    integrationManagement: {
      title: 'ပေါင်းစည်းမှု ဆက်တင်များ',
      description: 'ပြင်ပစနစ်များနှင့် ပေါင်းစည်းမှုများကို စီမံခန့်ခွဲရန်'
    },
    integrationSettings: {
      externalReference: {
        title: 'ပြင်ပ ရည်ညွှန်းချက် ပေါင်းစည်းမှု',
        description:
          'တစ်ကတ်ဖန်တီးခြင်းအတွက် ပြင်ပ ရည်ညွှန်းချက် ID ပေါင်းစည်းမှုကို စီမံခန့်ခွဲရန်',
        enable: 'ပြင်ပ ရည်ညွှန်းချက် ပေါင်းစည်းမှု ဖွင့်ရန်',
        enableDescription: 'ပြင်ပ ရည်ညွှန်းချက် ID ဝန်ဆောင်မှုနှင့် ပေါင်းစည်းမှုကို ဖွင့်ရန်',
        apiUrl: 'API လိပ်စာ',
        apiUrlDescription: 'ပြင်ပ ရည်ညွှန်းချက် ဝန်ဆောင်မှု API ၏ အခြေခံ လိပ်စာ',
        apiKey: 'API ကုဒ်',
        apiKeyDescription: 'ပြင်ပ ရည်ညွှန်းချက် ဝန်ဆောင်မှုကို ဝင်ရောက်ရန် အထောက်အထား ကုဒ်',
        apiKeyHeader: 'API ကုဒ် Header အမည်',
        apiKeyHeaderDescription:
          "API ကုဒ်အတွက် header အမည် (ဥပမာ: 'key', 'Authorization', 'X-API-Key')",
        timeout: 'အချိန်ကန့်သတ် (မီလီစက္ကန့်)',
        timeoutDescription: 'တောင်းဆိုချက် အချိန်ကန့်သတ် မီလီစက္ကန့်ဖြင့် (မူရင်း: ၅၀၀၀)',
        phoneField: 'ဖုန်းနံပါတ် ကွင်းအမည်',
        phoneFieldDescription:
          "API payload တွင် ဖုန်းနံပါတ်အတွက် parameter အမည် (ဥပမာ: 'phone', 'phoneNumber', 'mobile')",
        contentType: 'Content Type',
        contentTypeDescription: 'API တောင်းဆိုမှုအတွက် Content-Type header',
        testTitle: 'ပေါင်းစည်းမှု စမ်းသပ်ရန်',
        testDescription: 'ပြင်ပ ရည်ညွှန်းချက် ဝန်ဆောင်မှုနှင့် ချိတ်ဆက်မှုကို စမ်းသပ်ရန်',
        success: 'ဖောက်သည် အချက်အလက်များကို အောင်မြင်စွာ ရယူပြီးပါပြီ',
        error: 'ဖောက်သည် အချက်အလက်များ ရယူရာတွင် မအောင်မြင်ပါ',
        searchTitle: 'ပြင်ပ ရည်ညွှန်း ရှာဖွေပါ',
        lookupSuccess: 'ဖောက်သည် အချက်အလက်များကို အောင်မြင်စွာ ရယူပြီးပါပြီ',
        lookupError: 'ဖောက်သည် အချက်အလက်များ ရယူရာတွင် အမှားဖြစ်ပွားခဲ့သည်',
        lookupTimeout: 'တောင်းဆိုချက် အချိန်ကန့်သတ် ကျော်လွန်ခဲ့သည်',
        noCustomerFound: 'ဤဖုန်းနံပါတ်အတွက် ဖောက်သည် အချက်အလက် မတွေ့ရှိပါ'
      }
    },
    billingManagement: {
      title: 'ငွေတောင်းခံမှု စီမံခန့်ခွဲခြင်း',
      description: 'ငွေပေးချေမှုနှင့် ငွေတောင်းခံမှုဆိုင်ရာ အချက်အလက်များကို စီမံခန့်ခွဲရန်'
    },
    notifications: {
      integrationSettings: 'ပေါင်းစည်းမှု ဆက်တင်များ',
      enable: 'Push Notification များ ဖွင့်ရန်',
      apiUrl: 'API လိပ်စာ',
      authKey: 'အထောက်အထား ကုဒ်',
      notificationId: 'အကြောင်းကြားချက် ID',
      notificationIdDesc: 'ပြင်ပအကြောင်းကြားချက်ဝန်ဆောင်မှုမှ အသုံးပြုသော အကြောင်းကြားချက် ID',
      channelType: 'ချန်နယ်အမျိုးအစား',
      channelPush: 'ပုံတွန်း',
      channelEmail: 'အီးမေးလ်',
      channelSms: 'SMS',
      clientType: 'သုံးစွဲသူအမျိုးအစား',
      defaultIcon: 'မူရင်းသင်္ကေတ URL',
      saveSettings: 'ဆက်တင်များ သိမ်းဆည်းရန်',
      saving: 'သိမ်းဆည်းနေသည်...',
      testPushNotification: 'Push Notification  စမ်းသပ်ရန်',
      customerId: 'သုံးစွဲသူ ID',
      sendTest: 'စမ်းသပ်အကြောင်းကြားချက် ပို့ရန်',
      sending: 'ပို့နေသည်...',
      testSuccess: 'စမ်းသပ်အကြောင်းကြားချက် အောင်မြင်စွာ ပို့ပြီးပါပြီ',
      errorTest: 'စမ်းသပ်အကြောင်းကြားချက် ပို့ရာတွင် အမှားဖြစ်ပွားခဲ့သည်',
      errorTestAlert: 'စမ်းသပ်အကြောင်းကြားချက် ပို့ရာတွင် အမှားဖြစ်ပွားခဲ့သည်: ',
      settingsSaved: 'ဆက်တင်များကို အောင်မြင်စွာ သိမ်းဆည်းပြီးပါပြီ',
      settingsError: 'ဆက်တင်များ သိမ်းဆည်းရာတွင် အမှားဖြစ်ပွားခဲ့သည်'
    }
  },

  // Reports
  reports: {
    performance: {
      ticketsResolved: 'ဖြေရှင်းပြီးသော တောင်းဆိုချက်များ',
      avgResponseTime: 'ပျမ်းမျှ တုံ့ပြန်ချိန် (မိနစ်)',
      agentMetrics: 'အေးဂျင့် စွမ်းဆောင်ရည် တိုင်းတာမှုများ',
      avgResolutionTime: 'ပျမ်းမျှ ဖြေရှင်းချိန်',
      firstResponseTime: 'ပထမ တုံ့ပြန်ချိန်',
      customerSatisfaction: 'ဖောက်သည် စိတ်ကျေနပ်မှု'
    },
    filters: {
      title: 'စစ်ထုတ်မှုများ',
      dateRange: 'ရက်စွဲ အပိုင်းအခြား',
      status: 'အခြေအနေ',
      allStatuses: 'အခြေအနေ အားလုံး',
      priority: 'ဦးစားပေးအဆင့်',
      allPriorities: 'ဦးစားပေးအဆင့် အားလုံး',
      type: 'အမျိုးအစား',
      allTypes: 'အမျိုးအစား အားလုံး',
      group: 'အုပ်စု',
      allGroups: 'အုပ်စု အားလုံး'
    },
    sla: {
      responseTime: 'တုံ့ပြန်ချိန် SLA',
      resolutionTime: 'ဖြေရှင်းချိန် SLA',
      complianceOverTime: 'အချိန်အလိုက် SLA လိုက်နာမှု (%)',
      compliance: 'SLA လိုက်နာမှု',
      firstResponse: 'ပထမ တုံ့ပြန်မှု',
      target: 'ပန်းတိုင်: '
    },
    trends: {
      newTickets: 'တောင်းဆိုချက် အသစ်များ',
      volumeTrends: 'တောင်းဆိုချက် ပမာণ လမ်းကြောင်းများ',
      totalVolume: 'စုစုပေါင်း ပမာណ',
      avgResolutionTime: 'ပျမ်းမျှ ဖြေရှင်းချိန်',
      customerSatisfaction: 'ဖောက်သည် စိတ်ကျေနပ်မှု',
      firstContactResolution: 'ပထမအဆင့် ဆက်သွယ်မှု ဖြေရှင်းမှု',
      topCategories: 'ထိပ်တန်း အမျိုးအစားများ',
      priorityDistribution: 'ဦးစားပေးအဆင့် ခွဲဝေမှု',
      vsLastMonth: 'လွန်ခဲ့သော လနှင့် နှိုင်းယှဉ်ပါက',
      categories: {
        technical: 'နည်းပညာ ပြဿနာများ',
        billing: 'ငွေတောင်းခံမှု မေးခွန်းများ',
        feature: 'လုပ်ဆောင်ချက် တောင်းဆိုမှုများ',
        other: 'အခြား'
      },
      priorities: {
        urgent: 'အရေးပေါ်',
        high: 'မြင့်',
        medium: 'အလယ်အလတ်',
        low: 'နိမ့်'
      }
    }
  },

  // Memo
  memo: {
    title: 'ခေါင်းစဉ်',
    content: 'အကြောင်းအရာ',
    color: 'အရောင်',
    titleRequired: 'ခေါင်းစဉ် လိုအပ်သည်',
    contentRequired: 'အကြောင်းအရာ လိုအပ်သည်',
    titlePlaceholder: 'မှတ်စု ခေါင်းစဉ်',
    contentPlaceholder: 'သင့်မှတ်စုကို ဤနေရာတွင် ရေးပါ...',
    saveFailed: 'မှတ်စု သိမ်းဆည်းရန် မအောင်မြင်ပါ။ ထပ်မံကြိုးစားပါ။',
    deleteConfirm: 'ဤမှတ်စုကို ဖျက်မလား?',
    saving: 'သိမ်းဆည်းနေသည်...',
    saveMemo: 'မှတ်စု သိမ်းဆည်းရန်'
  },

  // Theme and UI
  theme: {
    switchToLight: 'အလင်းရောင် မုဒ်သို့ ပြောင်းရန်',
    switchToDark: 'အမှောင်ရောင် မုဒ်သို့ ပြောင်းရန်',
    openMenu: 'ပင်မမီနူး ဖွင့်ရန်'
  },

  // Errors
  errors: {
    applicationError: 'အက်ပ်ပလီကေးရှင်း အမှား',
    goBack: 'နောက်သို့ ပြန်သွားရန်',
    goHome: 'ပင်မစာမျက်နှာသို့ သွားရန်'
  },

  // Omni-Channel Integration
  atrium: {
    shortTitle: 'Atrium',
    title: 'The Atrium ပေါင်းစပ်မှု',
    description:
      'ဖောက်သည်များနှင့် ဆက်သွယ်မှုလမ်းကြောင်းများကို တစ်နေရာတည်းတွင် စီမံခန့်ခွဲနိုင်ရန် ချိတ်ဆက်ပါ',
    comingSoon: 'မကြာမီ ရောက်ရှိမည်...',
    conversations: 'The Atrium စကားဝိုင်းများ',
    noConversations: 'စကားဝိုင်းများ မတွေ့ရှိပါ',
    overview: 'The Atrium အခြေအနေခြုံငုံသုံးသပ်ချက်',
    activeChannels: '{{count}} လမ်းကြောင်း လုပ်ဆောင်နေသည်',
    activeChannels_plural: '{{count}} လမ်းကြောင်းများ လုပ်ဆောင်နေသည်',
    realtimeStats: 'အချိန်နှင့်တပြေးညီ မက်ဆေ့ခ်ျ စာရင်းအင်းများ',
    settings: 'The Atrium ဆက်တင်များ',
    agentStats: 'The Atrium အေးဂျင့် စာရင်းအင်းနှင့် တိုင်းတာချက်များ',
    filters: {
      title: 'စစ်ထုတ်မှုများ',
      active: 'အသက်ဝင်နေသည်',
      clearAll: 'အားလုံးရှင်းလင်းရန်',
      searchPlaceholder: 'စကားဝိုင်းများကို ရှာဖွေရန်...',
      status: 'အခြေအနေ',
      priority: 'ဦးစားပေး',
      channel: 'လမ်းကြောင်း',
      assignedTo: 'တာဝန်ပေးအပ်ထားသူ',
      allConversations: 'စကားဝိုင်းအားလုံး',
      unassigned: 'တာဝန်မပေးရသေး'
    },
    selectConversation: 'အသေးစိတ်ကြည့်ရှုရန် စကားဝိုင်းတစ်ခုကို ရွေးချယ်ပါ',
    messenger: {
      description: 'Facebook Messenger မှတစ်ဆင့် ဖောက်သည်များနှင့် ဆက်သွယ်ပါ',
      title: 'Facebook Messenger ချိတ်ဆက်ရန်',
      subtitle:
        'သင့်ဖောက်သည်များအား Facebook Messenger မှတစ်ဆင့် သင့်ထံ ဆက်သွယ်နိုင်ရန် ဖွင့်ပေးပါ',
      beforeStart: 'စတင်မီ',
      beforeStartDesc:
        'သင့်တွင် Facebook Page နှင့် Messenger ဖွင့်ထားသော Facebook App လိုအပ်ပါမည်။ သင့် credentials များရယူရန် အောက်ပါအဆင့်များကို လိုက်နာပါ။',
      stepByStep: 'အဆင့်ဆင့် လမ်းညွှန်:',
      continueBtn: 'ကျွန်ုပ်တွင် credentials များရှိပြီးပါပြီ၊ ဆက်လုပ်ရန်',
      continueToTesting: 'စမ်းသပ်ခြင်းသို့ ဆက်လုပ်ရန်',
      successMessage: 'Messenger လမ်းကြောင်းကို အောင်မြင်စွာ စီစဉ်ပြီးပါပြီ!',
      setupWebhook: 'Facebook Webhook ထည့်သွင်းခြင်း',
      setupWebhookDesc: 'စမ်းသပ်မီ၊ သင့် Facebook App တွင် webhook ကို စီစဉ်ရန် လိုအပ်ပါသည်',
      webhookStep1: 'သင့် Facebook App ရှိ Messenger Settings သို့ သွားပါ',
      webhookStep2: '"Webhooks" အပိုင်းကို ရှာပါ',
      webhookStep3: '"Add Callback URL" ကို နှိပ်ပါ',
      webhookStep4: 'အောက်ပါ URL နှင့် verify token ကို အသုံးပြုပါ',
      webhookUrl: 'Webhook Callback URL',
      verifyTokenFacebook: 'Verify Token (Facebook တွင် အသုံးပြုပါ)',
      subscribeFields: 'ဤ webhook fields များကို subscribe လုပ်ပါ:',
      testConnection: 'ချိတ်ဆက်မှု စမ်းသပ်ရန်',
      testConnectionDesc: 'Make sure your webhook is verified in Facebook before testing',
      testBtn: 'Test Connection',
      connectionSuccess: 'Connection Successful!',
      connectionFailed: 'Connection Failed',
      activateBtn: 'Activate Messenger Channel',
      steps: {
        setup: 'Facebook Setup',
        config: 'Configuration',
        test: 'Test & Activate'
      },
      guide: {
        step1: {
          title: 'Go to Facebook Developers',
          desc: 'Visit developers.facebook.com and create a new app'
        },
        step2: {
          title: 'Add Messenger Product',
          desc: 'In your app dashboard, add the Messenger product'
        },
        step3: {
          title: 'Connect Your Facebook Page',
          desc: 'Select the page you want to receive messages from'
        },
        step4: {
          title: 'Generate Page Access Token',
          desc: 'Click "Generate Token" and copy it (you\'ll need this in the next step)'
        },
        step5: {
          title: 'Get Your App Secret',
          desc: 'Go to Settings → Basic and copy your App Secret'
        }
      },
      form: {
        pageId: 'Facebook Page ID',
        pageIdDesc: 'Find this in your Facebook Page Settings → About → Page ID',
        pageAccessToken: 'Page Access Token',
        pageAccessTokenDesc:
          'Generated from Messenger Settings → Access Tokens in your Facebook App',
        appSecret: 'App Secret',
        appSecretDesc: 'Found in Settings → Basic in your Facebook App',
        verifyToken: 'Verify Token',
        verifyTokenDesc: 'Custom token for webhook verification (randomly generated)'
      }
    },
    email: {
      description: 'ဖောက်သည်များ၏ အီးမေးလ်များကို လက်ခံပြီး ပြန်ကြားရန်'
    },
    viber: {
      description: 'Viber မှတစ်ဆင့် ဖောက်သည်များနှင့် ဆက်သွယ်ပါ'
    },
    channelStatus: {
      title: 'Facebook Messenger',
      subtitle: 'လမ်းကြောင်း အခြေအနေနှင့် စီစဉ်ခြင်း',
      active: 'အသက်ဝင်နေသည်',
      inactive: 'အသက်မဝင်ပါ',
      connectedTo: 'Facebook Messenger သို့ ချိတ်ဆက်ထားသည်',
      configuredButInactive: 'လမ်းကြောင်းကို စီစဉ်ပြီးသော်လည်း အသက်မဝင်ပါ',
      pageId: 'Page ID',
      connectedOn: 'ချိတ်ဆက်ထားသည့်ရက်',
      status: 'အခြေအနေ',
      verified: 'အတည်ပြုပြီး',
      totalConversations: 'စကားဝိုင်းအရေအတွက်',
      messagesReceived: 'လက်ခံရရှိသော မက်ဆေ့ခ်ျများ',
      messagesSent: 'ပေးပို့ထားသော မက်ဆေ့ခ်ျများ',
      lastActivity: 'နောက်ဆုံး လှုပ်ရှားမှု',
      viewConfig: 'စီစဉ်ချက်ကို ကြည့်ရန်',
      hideConfig: 'စီစဉ်ချက်ကို ဖျောက်ရန်',
      manageAccess: 'ဝင်ခွင့်ကို စီမံရန်',
      hideAccess: 'ဝင်ခွင့်ကို ဖျောက်ရန်',
      test: 'စမ်းသပ်ရန်',
      testing: 'စမ်းသပ်နေသည်...',
      disable: 'ပိတ်ရန်',
      enable: 'ဖွင့်ရန်',
      processing: 'လုပ်ဆောင်နေသည်...',
      configurationDetails: 'စီစဉ်ချက် အသေးစိတ်',
      dangerZone: 'အန္တရာယ်ရှိသော နေရာ',
      dangerZoneWarning:
        'ဤလမ်းကြောင်းကို ဖြုတ်လိုက်ပါက စီစဉ်ချက်အချက်အလက်အားလုံးကို အပြီးအပိုင် ဖျက်ပစ်မည်ဖြစ်သည်။ လက်ရှိ စကားဝိုင်းများကို အရင် ဖြေရှင်းရပါမည်။',
      disconnectChannel: 'လမ်းကြောင်းကို ဖြုတ်ရန်',
      disconnecting: 'ဖြုတ်နေသည်...'
    },
    liveChat: {
      title: 'လိုက်ဖ်ချက် (Live Chat)',
      description: 'အက်ထရီယမ် လိုက်ဖ်ချက်ကို ထည့်သွင်းရန် ဝစ်ဂျက်ကီးကို ဖွင့်ပါ။',
      appId: 'အက်ပ် ID',
      saveConfig: 'သတ်မှတ်ချက်များကို သိမ်းဆည်းရန်',
      embedSnippet: 'ထည့်သွင်းရန် ကုဒ်',
      domains: 'ခွင့်ပြုထားသော ဒိုမိန်းများ',
      domainsHelp:
        'ခွင့်ပြုထားသော ဝဘ်ဆိုဒ်များကို ထည့်ပါ။ https://my-site.com ကဲ့သို့သော အပြည့်အစုံ သို့မဟုတ် https://*.my-site.com ကဲ့သို့သော wildcard subdomain များကို အသုံးပြုပါ။',
      personalization: 'စိတ်ကြိုက်ပြင်ဆင်ခြင်း',
      widgetTitle: 'ဝစ်ဂျက်ခေါင်းစဉ်',
      defaultWidgetTitle: 'တိုက်ရိုက်ပံ့ပိုးမှု',
      accentColor: 'အလေးပေးအရောင်',
      roundness: 'ဝိုင်းဝန်းမှု',
      roundnessNone: 'မရှိ (စတုရန်း)',
      roundnessNormal: 'ပုံမှန်',
      roundnessFull: 'အပြည့် (ဝိုင်းဝန်း)',
      confirmRemove:
        'လိုက်ဖ်ချက် သတ်မှတ်ချက်ကို ဖယ်ရှားမလား? ဤသည်မှာ ဝစ်ဂျက်ကီးကို ရပ်ဆိုင်းသွားစေမည်ဖြစ်သည်။',
      errorLoad: 'လိုက်ဖ်ချက် သတ်မှတ်ချက်ကို ဖတ်ရန် မအောင်မြင်ပါ',
      errorEnable: 'လိုက်ဖ်ချက်ကို ဖွင့်ရန် မအောင်မြင်ပါ',
      errorRemove: 'လိုက်ဖ်ချက် သတ်မှတ်ချက်ကို ဖယ်ရှားရန် မအောင်မြင်ပါ',
      errorCopy: 'ကူးယူရန် မအောင်မြင်ပါ',
      errorSave: 'သတ်မှတ်ချက်ကို သိမ်းဆည်းရန် မအောင်မြင်ပါ',
      errorInvalidWildcard: 'မမှန်ကန်သော wildcard ဒိုမိန်း: {{value}}',
      errorOnlyHttp: 'http/https ဒိုမိန်းများကိုသာ ခွင့်ပြုပါသည်: {{value}}',
      errorInvalidUrl: 'မမှန်ကန်သော ဒိုမိန်း URL: {{value}}',
      widgetPosition: 'ဝစ်ဂျက် တည်နေရာ',
      positionBottomRight: 'အောက်ညာဘက်',
      positionBottomLeft: 'အောက်ဘယ်ဘက်',
      positionTopRight: 'အပေါ်ညာဘက်',
      positionTopLeft: 'အပေါ်ဘယ်ဘက်',
      horizontalOffset: 'အလျားလိုက် အကွာအဝေး (px)',
      verticalOffset: 'ဒေါင်လိုက် အကွာအဝေး (px)',
      offsetHelp: 'မျက်နှာပြင်အနားသတ်များမှ အကွာအဝေး။'
    }
  },

  bot: {
    title: 'ဘော့ သတ်မှတ်ချက်',
    subtitle: 'အလိုအလျောက် တုံ့ပြန်မှုများနှင့် ဘော့ အပြုအမူကို စီစဉ်ပါ',
    settings: 'ဘော့ ဆက်တင်များ',
    rules: 'ဘော့ စည်းမျဉ်းများ',
    channel: 'လမ်းကြောင်း',
    selectChannel: 'လမ်းကြောင်းတစ်ခု ရွေးချယ်ပါ',
    enableAutoReplies: 'ဘော့ အလိုအလျောက် ပြန်ကြားမှုကို ဖွင့်ရန်',
    enableAutoRepliesDesc:
      'ဖွင့်လိုက်ပါက ဘော့သည် ဖောက်သည်များ၏ မက်ဆေ့ခ်ျများကို အလိုအလျောက် ပြန်ကြားမည်ဖြစ်သည်',
    messages: 'မက်ဆေ့ခ်ျများ',
    greetingMessage: 'နှုတ်ဆက်စကား',
    optional: '(ရွေးချယ်ခွင့်)',
    greetingPlaceholder: 'မင်္ဂလာပါ! 👋 FlowCXP မှ ကြိုဆိုပါတယ်! ဘယ်လိုကူညီပေးရမလဲ?',
    greetingSent: 'စကားဝိုင်းအသစ် စတင်သောအခါ အလိုအလျောက် ပေးပို့သည်',
    fallbackMessage: 'အရန် မက်ဆေ့ခ်ျ',
    fallbackSent: 'စည်းမျဉ်းများနှင့် မကိုက်ညီသောအခါ ပေးပို့သည်',
    statistics: 'စာရင်းအင်းများ',
    totalRules: 'စည်းမျဉ်းအရေအတွက်',
    activeRules: 'အသက်ဝင်နေသော စည်းမျဉ်းများ',
    totalTriggers: 'အသုံးပြုမှုအရေအတွက်',
    lastTriggered: 'နောက်ဆုံး အသုံးပြုခဲ့သည့်အချိန်',
    searchRules: 'စည်းမျဉ်းများကို ရှာဖွေရန်...',
    addRule: 'စည်းမျဉ်း ထည့်ရန်',
    noRulesYet: 'စည်းမျဉ်းများ မရှိသေးပါ',
    createFirstRule: 'အလိုအလျောက် တုံ့ပြန်မှုများ စတင်ရန် ပထမဆုံး စည်းမျဉ်းကို ဖန်တီးပါ',
    whenCustomerSays: 'ဖောက်သည် ပြောသောအခါ',
    botRespondsWith: 'ဘော့ ပြန်ကြားသည်',
    priority: 'ဦးစားပေး',
    used: 'အသုံးပြုခဲ့သည်',
    times: 'ကြိမ်'
  }
};
